import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const StyledSwitchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 288px;
  > div {
    margin-bottom: 12px;
  }
  @media ${DEVICES.sm} {
    width: 100%;
  }
`;

export const StyledSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .ant-form-item {
    width: 100%;
  }
  .switcher-field {
    width: 50px;
    .ant-form-item-control-input {
      min-height: auto;
    }
  }
  @media ${DEVICES.sm} {
    align-items: flex-start;
  }
`;
